import { v4 as uuid } from 'uuid';

import { type TicketItem } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import { SUB_CART_ITEM_TYPES } from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';
import {
  type Cart,
  type CartItemsAttributes,
  type TicketCartItem,
  type TicketCartItemAttributes,
} from 'hb-react/shared/components/ShoppingCard/hooks/v2';

export const initCart = (
  tickets: Array<TicketItem>,
  cart?: Partial<Cart>,
): Array<CartItemsAttributes> => {
  if (cart?.cart_items && cart.cart_items?.length > 0) {
    const cartItems = cart.cart_items;

    const ticketItems = tickets.flatMap((cartTicket) => {
      const quantity = Number(cartTicket.cartItem?.quantity || 0);

      const attendees = cartItems.filter(
        (item): item is TicketCartItem =>
          item.line_itemable_type === 'NetworkEvents::Ticket' &&
          item.line_itemable_id === cartTicket.id,
      );

      return Array.from({ length: quantity }).map(
        (_): TicketCartItemAttributes => {
          const attendee = attendees.shift();

          return {
            line_itemable_id: cartTicket.id,
            line_itemable_type: 'NetworkEvents::Ticket',
            currency: cartTicket.currency,
            quantity: 1,
            metadata: {
              event: {
                uuid: uuid(),
                ...attendee?.metadata?.event,
                ticket_id: cartTicket.id,
                isFree: cartTicket.isFree,
                type: 'ticket',
              },
            },
          };
        },
      );
    });

    const ids = ticketItems.map(({ metadata }) => metadata?.event?.uuid);

    return [
      ...cartItems.filter((item) => {
        if (item.line_itemable_type === 'Donation::Campaign') {
          return true;
        }

        if (item.line_itemable_type === 'Ecommerce::Products::EventAddon') {
          return (
            item?.metadata?.event?.type ===
              SUB_CART_ITEM_TYPES.STANDALONE_ADDON ||
            ids.includes(item?.metadata?.event?.parent_uuid)
          );
        }

        return false;
      }),
      ...ticketItems,
    ];
  }

  return tickets.flatMap((cartTicket): Array<TicketCartItemAttributes> => {
    const quantity = Number(cartTicket.cartItem?.quantity || 0);

    return Array.from({ length: quantity }).map((_) => ({
      line_itemable_type: 'NetworkEvents::Ticket',
      line_itemable_id: cartTicket.id,
      currency: cartTicket.currency,
      quantity: 1,
      metadata: {
        event: {
          isFree: cartTicket.isFree,
          uuid: uuid(),
          ticket_id: cartTicket.id,
          type: 'ticket',
        },
      },
    }));
  });
};
